export const CRON_EVENT = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    RECONNECT: 'reconnect',
    CONNECT_ERROR: 'connect_error',
    RECONNECT_ATTEMPT: 'reconnect_attempt',
    REGISTER_USER: 'register-user',
    SEND_MESSAGE: 'send-message',
    USER_LOGOUT: 'user-logout',
    USER_ONLINE: 'user-online',
    USER_OFFLINE: 'user-offline',
    SALESFORCE_CRON: 'salesforce-cron-status',
};

export const SALESFORCE_CRON_STATUS = {
    IN_PROGRESS: 'in-progress',
    COMPLETED: 'completed',
    FAILED: 'failed',
    NO_UPDATES: 'no-updates',
}